import React, { useState, useEffect, useContext } from "react";
import { Form, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useProductUom } from "../../hooks/useProductUom";
import { useUom } from "../../hooks/useUom";
import ProductUomForm from "./ProductUomForm";
import { AccountContext } from "../layouts/BaseLayout";

const NewProductUomModal = (props) => {
  const { item, visible, setVisible, dispatch } = props;

  const { account } = useContext(AccountContext);

  const { t } = useTranslation();

  const [form] = Form.useForm();

  const { findAll } = useUom();

  const { create } = useProductUom();

  const [submitting, setSubmitting] = useState(false);

  const [uomOptions, setUomOptions] = useState([]);

  useEffect(() => {
    if (visible && account.Companies) {
      findAll({
        companyId: account.Companies[0].id,
      }).then((res) => {
        if (res.status === "success") {
          setUomOptions(res.data);
        }
      });
    }
  }, [visible, account.Companies, findAll]);

  const handleOk = (e) => {
    form.validateFields().then((values, err) => {
      if (!err) {
        const params = {
          productId: item.id,
          uomId: values.uomId,
          conversionFactor: values.conversionFactor,
          isBaseUom: values.isBaseUom,
          isSaleUom: values.isSaleUom,
        };
        create(params).then((res) => {
          if (res.status === "success") {
            dispatch({ type: "refresh" });
            setVisible(false);
            form.resetFields();
          }
          setSubmitting(false);
        });
      }
    });
  };

  const handleCancel = () => setVisible(false);

  return (
    <Modal
      title={t("uom.addNewTitle")}
      confirmLoading={submitting}
      centered
      visible={visible}
      destroyOnClose
      onCancel={handleCancel}
      onOk={handleOk}
      okText={t("action.submit")}
      cancelText={t("action.cancel")}
    >
      <ProductUomForm form={form} uomOptions={uomOptions} />
    </Modal>
  );
};

export default NewProductUomModal;
